import React, { useState } from 'react';
import { classNames, initialsFromName } from '@/lib/format';

export const Avatar = ({ name, size = 32, className, src }) => {
  const initials = initialsFromName(name || '');
  const s = `${size}px`;
  const [imgFailed, setImgFailed] = useState(false);
  const showImg = Boolean(src) && !imgFailed;

  return (
    <span
      className={classNames(
        'relative inline-grid shrink-0 place-items-center overflow-hidden rounded-full border bg-secondary text-foreground/80',
        className,
      )}
      style={{ width: s, height: s, fontSize: Math.round(Number(size) * 0.4) || 12 }}
    >
      {showImg ? (
        <img
          src={src}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          onError={() => setImgFailed(true)}
          data-testid="avatar-image"
        />
      ) : (
        <span className="font-semibold tracking-tight">{initials || '?'}</span>
      )}
    </span>
  );
};
